/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import { Search } from 'src/common/components';
import { RemoteSelect } from 'src/common/components/Select';

import { useLegalEntityListContext } from '../context';

import CreateLegalEntityButton from './CreateLegalEntityButton';

const LegalEntityFilter = (): JSX.Element => {
  const { actions } = useLegalEntityListContext();
  const { searchByName, searchByAccount } = actions;

  const handleLegalEntity = (legalEntityName: string): void => {
    searchByName(legalEntityName);
  };

  const handleAccount = (element: unknown): void => {
    searchByAccount(element ? (element as any).value : '');
  };

  return (
    <div className="grid grid-cols-3 gap-4 mb-4">
      <div>
        <Search
          setSearch={handleLegalEntity}
          placeholder="Name / Account Name"
          className="sm:w-full"
        />
      </div>
      <div>
        <RemoteSelect
          url="account_admin?basic_info=true"
          cacheOptions
          placeholder="Account"
          fieldLabel="name"
          fieldId="name"
          onChange={handleAccount}
          isClearable
          dataPath="results"
        />
      </div>
      <div className="flex justify-end">
        <CreateLegalEntityButton />
      </div>
    </div>
  );
};

export default LegalEntityFilter;
